var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-spinner"},[_c('div',{staticClass:"v-sync v-sync1",style:([_vm.spinnerStyle,_vm.spinnerDelay1])}),_c('div',{staticClass:"v-sync v-sync2",style:([_vm.spinnerStyle,_vm.spinnerDelay2])}),_c('div',{staticClass:"v-sync v-sync3",style:([_vm.spinnerStyle,_vm.spinnerDelay3])})])
}
var staticRenderFns = []

export { render, staticRenderFns }